import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import moment from "moment-timezone";
import { Field } from "../../../../components/shared/Form";
import CustomTimeInput from "../../../../components/shared/inputs/CustomTimeInput";
import PayCodeSelect from "../../../TraxxionSchedule/Component/components/drawers/Event/Form/components/PayCodeSelect";
import LevelSelect from "../../../TraxxionSchedule/Component/components/drawers/Event/Form/components/LevelSelect";
import { JobSelect, LocationSelect } from "./ObjectSelect";
import { useGroups } from "../../../Settings/General/OrganisationLevelGroups/context";
import { combineDateAndTime, renderDurationAsFormat } from "../../../../utils/helpers/date";

function Simple({ user, disabled }) {
    const { t } = useTranslation();
    const { allocatedGroups } = useGroups();
    const { control } = useFormContext();
    const [date, start, end] = useWatch({ control, name: ["date", "startDate", "endDate"] });

    const duration = useMemo(() => {
        if (!start || !end) {
            return 0;
        }
        const _start = combineDateAndTime(moment(date), moment(start));
        let _end = combineDateAndTime(moment(date), moment(end));
        if (moment(_end).isBefore(moment(_start), "seconds")) {
            _end = moment(_end).add(1, "day");
        }
        return moment(_end).diff(moment(_start), "seconds");
    }, [start, end, date]);

    return (
        <>
            <div className="tw-flex tw-items-start tw-gap-9">
                <Field name="startDate" label={t("start")} layout="row" deps={["endDate"]} shouldUnregister={false}>
                    <CustomTimeInput placeholder={t("start")} disabled={disabled} />
                </Field>

                <div className="tw-flex tw-items-start tw-gap-9">
                    <Field
                        name="endDate"
                        label={t("end")}
                        layout="row"
                        deps={["startDate"]}
                        className="tw-grid-cols-[50px_1fr]"
                        shouldUnregister={false}
                    >
                        <CustomTimeInput placeholder={t("end")} disabled={disabled} />
                    </Field>
                    <div className="tw-text-sm tw-font-semibold tw-mb-4 tw-pt-2">
                        {renderDurationAsFormat(duration, "HH:mm")} {t("hours")}
                    </div>
                </div>
            </div>

            <Field name="payCode" label={t("pay-code")} layout="row" shouldUnregister={false}>
                <PayCodeSelect placeholder={t("pay-code")} disabled={disabled} />
            </Field>

            <Field name="job" label={t("job")} layout="row" shouldUnregister={false}>
                <JobSelect user={user} placeholder={t("job")} disabled={disabled} />
            </Field>

            <Field name="location" label={t("location")} layout="row" shouldUnregister={false}>
                <LocationSelect user={user} placeholder={t("location")} disabled={disabled} />
            </Field>

            {allocatedGroups?.map((group) => (
                <Field
                    key={group.id}
                    name={group.level.replaceAll("_", "")}
                    label={group.description}
                    layout="row"
                    shouldUnregister={false}
                >
                    <LevelSelect group={group.id} allowClear={!group.isRequired} disabled={disabled} />
                </Field>
            ))}
        </>
    );
}

export default Simple;
